import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import AccountSettingsCard from '@/components/profile/AccountSettingsCard';
import { useAuth } from '@/contexts/AuthContext';
import { adminScopes } from '@/lib/auth';
import { ShieldCheck, UserCog } from 'lucide-react';

const scopeLabels = {
  academic: 'Academic',
  student: 'Student',
  admin: 'Admin',
};

export default function AdminProfile() {
  const { profile } = useAuth();
  const scopes = adminScopes(profile);

  return (
    <div className="space-y-6 animate-fade-in" data-testid="admin-profile-page">
      <div>
        <h2
          className="text-2xl font-semibold text-[#062B1A]"
          style={{ fontFamily: 'var(--font-display)' }}
        >
          My Profile
        </h2>
        <p className="mt-1 text-sm text-[#062B1A]/60">
          Manage your login details and password.
        </p>
      </div>

      <Card className="border border-[rgba(6,43,26,0.08)] shadow-sm">
        <CardHeader className="border-b border-[rgba(6,43,26,0.08)]">
          <CardTitle
            className="flex items-center gap-2 text-base font-semibold text-[#062B1A]"
            style={{ fontFamily: 'var(--font-display)' }}
          >
            <UserCog className="h-4 w-4 text-[#D4AF37]" />
            Admin access
          </CardTitle>
        </CardHeader>
        <CardContent className="flex flex-wrap items-center gap-2 pt-5">
          {profile?.is_super_admin && (
            <Badge
              variant="outline"
              className="border-[#062B1A]/20 bg-[#062B1A]/5 text-[#062B1A]"
            >
              <ShieldCheck className="mr-1 h-3 w-3" />
              Super Admin
            </Badge>
          )}
          {scopes.map((scope) => (
            <Badge
              key={scope}
              variant="outline"
              className="border-[#D4AF37]/35 bg-[#D4AF37]/10 text-[#8A6508]"
            >
              <ShieldCheck className="mr-1 h-3 w-3" />
              {scopeLabels[scope] || scope}
            </Badge>
          ))}
          {scopes.length === 0 && (
            <span className="text-sm text-[#062B1A]/55">No admin access scopes assigned.</span>
          )}
        </CardContent>
      </Card>

      <AccountSettingsCard />
    </div>
  );
}
